import { useEffect, useRef } from 'react';

export const useParallax = (enabled: boolean) => {
  const rafRef = useRef<number | null>(null);

  useEffect(() => {
    if (!enabled || typeof window === 'undefined') return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    const nodes = Array.from(document.querySelectorAll<HTMLElement>('[data-parallax]'));
    if (!nodes.length) return;

    const mobileMultiplier = window.matchMedia('(max-width: 767px)').matches ? 0.55 : 1;

    const onScroll = () => {
      if (rafRef.current) return;
      rafRef.current = requestAnimationFrame(() => {
        rafRef.current = null;
        const scrollY = window.scrollY;

        nodes.forEach((n) => {
          const speed = (parseFloat(n.dataset.parallax || '0') || 0) * mobileMultiplier;
          const limit = parseFloat(n.dataset.parallaxLimit || '320') || 320;
          const rawOffset = scrollY * speed;
          const off = Math.max(-limit, Math.min(limit, rawOffset));
          n.style.transform = `translate3d(0, ${off.toFixed(1)}px, 0)`;
        });
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    return () => {
      window.removeEventListener('scroll', onScroll);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      nodes.forEach((n) => n.style.removeProperty('transform'));
    };
  }, [enabled]);
};
